import { Component, computed, inject, signal } from '@angular/core';
import { QuestionOption, QuestionType } from '@empathy/survey/base';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-conditional-range-form',
  templateUrl: './conditional-range-form.component.html',
  styleUrls: ['./conditional-range-form.component.scss']
})
export class ConditionalRangeFormComponent {
  fromValue$ = signal<QuestionOption | null>(null);

  fromOptions$ = computed(() => {
    const to = this.toValue$();
    return to ? this.surveyConditionalsService.options$().filter((v) => +v.value < +to.value) : this.surveyConditionalsService.options$();
  });

  toValue$ = signal<QuestionOption | null>(null);
  toOptions$ = computed(() => {
    const from = this.fromValue$();
    return from ? this.surveyConditionalsService.options$().filter((v) => +v.value > +from.value) : this.surveyConditionalsService.options$();
  });

  surveyConditionalsService = inject(SurveyConditionalsService);

  onFromValueChange(value: QuestionOption): void {
    this.fromValue$.set(value);
    this.updateValueToMatch();
  }

  onToValueChange(value: QuestionOption): void {
    this.toValue$.set(value);
    this.updateValueToMatch();
  }

  private mapRanks(): QuestionOption[] {
    return this.surveyConditionalsService.questionSelected$().type === QuestionType.Ranking
      ? this.surveyConditionalsService.questionSelected$().options
      : Array.from(
          { length: this.surveyConditionalsService.questionSelected$().ratingScale },
          (_, index) => this.surveyConditionalsService.questionSelected$().options[index]
        );
  }

  private updateValueToMatch(): void {
    if (this.fromValue$() && this.toValue$()) {
      this.surveyConditionalsService.conditionForm$().get('valueToMatch').setValue([this.fromValue$().id, this.toValue$().id]);
    } else {
      this.surveyConditionalsService.conditionForm$().get('valueToMatch').reset();
    }
  }
}
